if (!customElements.get("section-combination")) {
    customElements.define(
      "section-combination",
      class SectionCombination extends HTMLElement {
        // 机器容量/板子数量*板子输出功率*0.75
        // 户外电源能耗公式 Capacity / (panel_number * spec) = time
  
        constructor() {
          super();
          this.sectionId = this.dataset.sectionId;
          // 板子规格集合
          this.panel_types = [200, 100];
          // 板子转化率
          this.rate = 0.75;
          // 默认选中的板子规格 0 200w 1 100w
          this.panel_avtive_type = 0;
          // 默认选中板子数量 0-> 1 ,1->2 , 2-> 3 .... n-> n+1
          this.panel_pice_avtive_number = 0;
          // 电源型号 0 INFINITY1500 ,1 INFINITY1300, 2 VITA550
          this.power_supply_types = this.getPowerSupplyTypes();
          // 选中的移动电源类型 0 1500 ,1 1300, 2 550
          this.battery_active_type = 0;
  
          // 电源类型集合
          this.battery_types = [
            {
              type: 0,
              capacity: 1512,
              title: this.power_supply_types[0],
            },
            {
              type: 1,
              capacity: 1382,
              title: this.power_supply_types[1],
            },
            {
              type: 2,
              capacity: 538,
              title: this.power_supply_types[2],
            },
          ];
  
          this.init();
        }
  
        getPowerSupplyTypes() {
          return (
            Array.from(
              this.querySelectorAll(".combination-product-item-title")
            )?.map((t) => t.innerText) ?? []
          );
        }
  
        init() {
          this.swiper_panel_container = this.swiperPanel(
            "#swiper-panel-container"
          );
          this.swiper_paner100 = this.swiperPanel("#swiper-panel-100-container");
          this.swiper_paner200 = this.swiperPanel("#swiper-panel-200-container");
          this.swiper_panel_container.allowTouchMove = false;
          this.swiper_paner100.allowTouchMove = false;
          this.swiper_paner200.allowTouchMove = false;
  
          this.combinationPanelTab();
          this.combinationTab();
          this.combinationProductTab();
  
          this.updataBatteryContent();
        }
  
        swiperPanel(swiperId) {
          return new Swiper(
            this.querySelector(swiperId, {
              slidesPerView: 1,
              spaceBetween: 0,
              allowTouchMove: false,
            })
          );
        }
  
        combinationTab() {
          const _this = this;
          _this.tabItems = Array.from(
            this.querySelectorAll(".section-combination-tab-item")
          );
          _this.tabItems.forEach((item, index) => {
            item.onclick = function () {
              $(_this.tabItems).not(item).removeClass("active");
              item.classList.add("active");
              _this.panel_pice_avtive_number = index;
              _this.panel_avtive_type == 0
                ? _this.swiper_paner200.slideTo(index)
                : _this.swiper_paner100.slideTo(index);
              _this.updataBatteryContent();
  
              index != 0
                ? _this.productItems[2].classList.add("visibility-hidden")
                : _this.productItems[2].classList.remove("visibility-hidden");
            };
          });
        }
  
        combinationPanelTab() {
          const _this = this;
          const panelTabItem = this.querySelectorAll(
            ".combination-panel-tab-item"
          );
          Array.from(panelTabItem).forEach((item, index) => {
            item.onclick = function () {
              $(panelTabItem).not(item).removeClass("active");
              item.classList.add("active");
              _this.swiper_panel_container.slideTo(index);
              _this.panel_avtive_type = index;
              index == 0
                ? _this.swiper_paner200.slideTo(_this.panel_pice_avtive_number)
                : _this.swiper_paner100.slideTo(_this.panel_pice_avtive_number);
              _this.updataBatteryContent();
            };
          });
        }
  
        combinationProductTab() {
          const _this = this;
          _this.productItems = Array.from(
            this.querySelectorAll(".combination-product-item")
          );
          _this.productItems.forEach((item, index) => {
            item.onclick = function () {
              $(_this.productItems).not(item).removeClass("active");
              item.classList.add("active");
              _this.battery_active_type = index;
              _this.updataBatteryContent();
  
              if (index == 2) {
                _this.tabItems.forEach(
                  (t, i) => i != 0 && t.classList.add("visibility-hidden")
                );
  
                _this.panel_pice_avtive_number = 0;
                _this.panel_avtive_type == 0
                ? _this.swiper_paner200.slideTo(_this.panel_pice_avtive_number)
                : _this.swiper_paner100.slideTo(_this.panel_pice_avtive_number);
                
              _this.updataBatteryContent();
              } else {
                _this.tabItems.forEach((t, i) =>
                  t.classList.remove("visibility-hidden")
                );
              }
            };
          });
        }
  
        /**
         * 更新组合文案内容
         * 机器容量/板子数量*板子输出功率*0.75
         * 户外电源能耗公式 Capacity / (panel_number * spec * 0.75) = time
         * 结果区间 0.5
         */
  
        updataBatteryContent() {
          let time_nodes = this.querySelectorAll(
            `#product-time-${this.sectionId}`
          );
          let text_nodes = this.querySelectorAll(
            `#product-text-${this.sectionId}`
          );
          let hours =
            this.battery_types[this.battery_active_type].capacity /
            ((this.panel_pice_avtive_number + 1) *
              this.panel_types[this.panel_avtive_type] *
              this.rate);
  
          Array.from(text_nodes).forEach(
            (t) =>
              (t.innerText =
                'Ladezeit für ' + this.battery_types[this.battery_active_type].title)
          );
  
          Array.from(time_nodes).forEach(
            (t) =>
              (t.innerText = `${(Number(hours.toFixed(1)) - 0.2).toFixed(1)} ~ ${(
                Number(hours.toFixed(1)) + 0.3
              ).toFixed(1)} Stunden`)
          );
        }
      }
    );
  }
  